module.exports = __webpack_public_path__ + "static/media/coin_gray.dcd8877b.svg";